import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';

import FolxLogo from '@ui/atoms/FolxLogo';

import { getColorFromTheme } from '@utils/theme';

import { SpacingTypes } from '@folx-types/theme';

import theme from '@theme/FolxTheme';

interface IFolxHeaderProps {
	children?: ReactNode;
	className?: string;
	headerSpacing?: SpacingTypes;
	centerContent?: ReactNode;
	leftContent?: ReactNode;
	rightContent?: ReactNode;
	bottomContent?: ReactNode;
	topBarHeight?: SpacingTypes;
	sticky?: boolean;
}

interface IHeaderBarProps {
	padding: SpacingTypes;
	height: SpacingTypes;
}

const Header = styled.header<IFolxHeaderProps>`
	display: flex;
	flex-direction: column;
	position: ${({ sticky = false }) => (sticky ? 'sticky' : 'relative')};
	top: ${({ sticky = false }) => sticky && 0};
	z-index: ${({ sticky = false }) => sticky && theme.zIndexes.header};
	width: 100%;
`;

const HeaderBar = styled.div<IHeaderBarProps>`
	background: ${({ theme: components }) =>
		getColorFromTheme(components.folxHeader.backgroundColor, components.folxHeader.backgroundTint)};
	padding: ${({ padding }) => theme.spacing[padding]} ${theme.spacing.md};
	border-bottom: ${({ theme: components }) =>
		!!components.folxHeader?.borderBottom && components.folxHeader.borderBottom};
	@media ${theme.responsive.breakpoints.tablet} {
		padding: ${({ padding }) => theme.spacing[padding]} ${theme.spacing.xxl};
	}
`;

const BarContentWrapper = styled.div`
	display: flex;
	flex-grow: 1;
	justify-content: center;
	align-items: center;
	margin: 0 auto;
	max-width: 144rem;
`;

const LeftHeaderContent = styled.div`
	display: flex;
	flex: 1 1 50%;
	margin-right: ${theme.spacing.sm};

	@media ${theme.responsive.breakpoints.laptop} {
		flex: 1 1 0%;
	}
`;

const RightHeaderContent = styled.div`
	display: flex;
	flex: 1 1 50%;
	justify-content: flex-end;
	margin-left: ${theme.spacing.sm};

	@media ${theme.responsive.breakpoints.laptop} {
		flex: 1 1 100%;
	}
`;

const FolxHeader: FC<IFolxHeaderProps> = ({
	children,
	className,
	headerSpacing = 'xs',
	leftContent,
	centerContent,
	rightContent,
	bottomContent,
	topBarHeight = 'sm',
	sticky = false,
}) => {
	return (
		<Header className={className} sticky={sticky}>
			<HeaderBar padding={headerSpacing} height={topBarHeight}>
				{children ?? (
					<BarContentWrapper>
						<LeftHeaderContent>{leftContent}</LeftHeaderContent>
						{centerContent ?? <FolxLogo />}
						<RightHeaderContent>{rightContent}</RightHeaderContent>
					</BarContentWrapper>
				)}
			</HeaderBar>
			{bottomContent}
		</Header>
	);
};

export default styled(FolxHeader)``;
